const loadingLabel = "Lade";
const deCH = {
  loadingLabel
};
export {
  deCH as default,
  loadingLabel
};
